/**
 * 跳转app的一些常量
 */
export var MqqSchemaTpl = 'mqqapi://forward/url?src_type=web&version=1&url_prefix=';
export var MqqAndriodTpl = 'mqqapi://forward/url?src_type=web&plg_auth=1&url_prefix=';
export var MqqChromeTpl = 'intent://forward/url?src_type=web&style=default&plg_auth=1&version=1&url_prefix=';
export var MqqChromeAfterTpl = '#Intent;scheme=mqqapi;package=com.tencent.mobileqq;end';
// TODO NOTICE 后续添加新的 schema 时请一定注明用处及相关人员 NOTICE
export var QQSchemaList = [
    '^mqqapi://forward/url',
    // 这三个是祖传的, 不知道干什么的
    '^mqqapi://forward/invite_register',
    '^mqqapi://qstory/publish',
    // 消息列表 (之前只有 iOS 支持, 安卓 818 以后版本支持
    '^mqqapi://msg_list/forward_msg_list',
    // 打开空间 (后面 query 里带一堆参数, 这里不好限制) —— kelvinsun
    '^mqqapi://qzoneschema',
    // 手 Q 相机 —— xiaoweisun
    '^mqqapi://videostory/takevideo',
    // 通过 uin 拉起 c2c 聊天 —— kelvinsun
    '^mqqapi://im/chat\\?src_type=web&version=1&chat_type=c2c&uin=\\d+',
    // 分享好友资料卡到微信 —— seacenliu
    '^mqqapi://userprofile/friend_profile_card',
    // 安卓侧拉起消息列表 - hyimzhong
    '^mqqapi://page_router/open_conversation',
    '^mqqapi://qcircle',
];
